"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Download = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Download = function Download() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.98001C12.2761 2.98001 12.5 3.20387 12.5 3.48001V16.452L16.3442 12.5587C16.5382 12.3622 16.8548 12.3602 17.0513 12.5542C17.2478 12.7482 17.2498 13.0648 17.0558 13.2613L12.3558 18.0213C12.2618 18.1164 12.1337 18.17 12 18.17C11.8663 18.17 11.7381 18.1164 11.6442 18.0213L6.9442 13.2613C6.75018 13.0648 6.75219 12.7482 6.94868 12.5542C7.14518 12.3602 7.46176 12.3622 7.65578 12.5587L11.5 16.452V3.48001C11.5 3.20387 11.7239 2.98001 12 2.98001ZM4 17.97C4 17.6939 3.77614 17.47 3.5 17.47C3.22386 17.47 3 17.6939 3 17.97V19.09C3 20.1561 3.86386 21.02 4.93 21.02H19.07C20.1361 21.02 21 20.1561 21 19.09V17.97C21 17.6939 20.7761 17.47 20.5 17.47C20.2239 17.47 20 17.6939 20 17.97V19.09C20 19.6039 19.5839 20.02 19.07 20.02H4.93C4.41614 20.02 4 19.6039 4 19.09V17.97Z"
    })
  });
};
exports.Download = Download;